import moment from 'moment';
import { API_REQUEST, hideDialog } from '../../core/actions';
import * as EssentialTaskAPI from '../../core/api/essential-tasks';
import * as taskCompletionsAPI from '../../core/api/task-completions';
import * as taskLocationAPI from '../../core/api/task-locations';
import * as taskPrefixAPI from '../../core/api/task-prefixes';
import * as TaskAPI from '../../core/api/tasks';
import * as FileApi from '../../core/api/files';
import { viewPermissionRefs } from '../../core/components/UserGroupPermissions';
import { getTodaysTaskCompletionsDefaultQuery } from './helpers';

export const SAVE_TASK = 'SAVE_TASK';
export const ADD_TASK = 'ADD_TASK';
export const ADD_TASKS = 'ADD_TASKS';
export const ADD_PART = 'ADD_PART';
export const FETCH_TASKS = 'FETCH_TASKS';
export const FETCH_QUICK_TASKS = 'FETCH_QUICK_TASKS';
export const ADD_QUICK_TASK = 'ADD_QUICK_TASK';
export const DELETE_QUICK_TASK = 'DELETE_QUICK_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASKINEDIT = 'DELETE_TASKINEDIT';
export const GET_TASK = 'GET_TASK';
export const GET_QUICK_TASK = 'GET_QUICK_TASK';
export const UNLINK_TASK = 'UNLINK_TASK';
export const GET_MAINTENANCE_TASK = 'GET_MAINTENANCE_TASK';
export const SET_MAINTENANCE_TASK = 'SET_MAINTENANCE_TASK';
export const ADD_TASK_COMPLETION = 'ADD_TASK_COMPLETION';
export const GET_TASK_COMPLETIONS_FOR_TASK = 'GET_TASK_COMPLETIONS_FOR_TASK';
export const GET_ALL_TASK_COMPLETIONS = 'GET_ALL_TASK_COMPLETIONS';
export const GET_COMPLETED_TASK_COMPLETIONS = 'GET_COMPLETED_TASK_COMPLETIONS';
export const GET_SNOOZED_TASK_COMPLETIONS = 'GET_SNOOZED_TASK_COMPLETIONS';
export const GET_TODAYS_TASK_COMPLETIONS = 'GET_TODAYS_TASK_COMPLETIONS';
export const GET_ESSENTIAL_TASKS = 'GET_ESSENTIAL_TASKS';
export const ADD_ESSENTIAL_TASK = 'ADD_ESSENTIAL_TASK';
export const ADD_TASK_NOTE = 'ADD_TASK_NOTE';
export const UPDATE_TASK_NOTE = 'UPDATE_TASK_NOTE';
export const DELETE_ESSENTIAL_TASK = 'DELETE_ESSENTIAL_TASK';
export const SAVE_ESSENTIAL_TASK = 'SAVE_ESSENTIAL_TASK';
export const SET_TASK_FROM_DATE = 'SET_TASK_FROM_DATE';
export const SET_TASK_UNTIL_DATE = 'SET_TASK_UNTIL_DATE';
export const SET_TASK_SELECTIONS = 'SET_TASK_SELECTIONS';
export const CLEAR_TASK_SELECTIONS = 'CLEAR_TASK_SELECTIONS';
export const FETCH_TASK_PREFIXES = 'FETCH_TASK_PREFIXES';
export const FETCH_TASK_LOCATIONS = 'FETCH_TASK_LOCATIONS';
export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const SET_PREFIX_FILTER = 'SET_PREFIX_FILTER';
export const SET_LOCATION_FILTER = 'SET_LOCATION_FILTER';
export const SET_EMPLOYEE_FILTER = 'SET_EMPLOYEE_FILTER';
export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const SET_INTERVAL_FILTER = 'SET_INTERVAL_FILTER';
export const CLEAR_MAINTENANCE_TASK = 'CLEAR_MAINTENANCE_TASK';
export const GET_COMPLETION_LOGS = 'GET_COMPLETION_LOGS';
export const SET_CURRENT_EMPLOYEE = 'SET_CURRENT_EMPLOYEE';
export const GET_LAST_FOUR_HOURS_TASKS = 'GET_LAST_FOUR_HOURS_TASKS';
export const CLEAR_NEW_TASK = 'CLEAR_NEW_TASK';
export const GET_CALENDAR_TASK_COMPLETIONS = 'GET_CALENDAR_TASK_COMPLETIONS';
export const FETCH_MAINTENANCE_TASKS = 'FETCH_MAINTENANCE_TASKS';
export const ADD_TASK_FILE = 'ADD_TASK_FILE';
export const DELETE_TASK_FILE = 'DELETE_TASK_FILE';
export const FETCH_PROJECT_TASKS = 'FETCH_PROJECT_TASKS';

let lastTasksQuery = {};

export const getLastTasksQuery = () => lastTasksQuery || {};

export const fetchTasks = (query) => {
  lastTasksQuery = query || {};
  return {
    type: API_REQUEST,
    callAPI: TaskAPI.fetchTasks,
    data: { query },
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
    action: FETCH_TASKS,
  };
};

export const fetchProjectTasks = (query) => {
  const { siteIds, ...rest } = query || {};
  return {
    type: API_REQUEST,
    callAPI: TaskAPI.fetchTasks,
    data: { query: { ...rest, type: 'Project' } },
    meta: {
      permissionKey: viewPermissionRefs.task,
      useManagerSiteId: true,
      ...(siteIds?.length ? { additionalSiteIds: siteIds } : {}),
    },
    action: FETCH_PROJECT_TASKS,
  };
};

export const fetchQuickTasks = (query) => {
  return {
    type: API_REQUEST,
    callAPI: TaskAPI.fetchQuickTasks,
    data: { query },
    meta: { permissionKey: viewPermissionRefs.task },
    action: FETCH_QUICK_TASKS,
  };
};
export const addTask = (task) => {
  const hasWrapper =
    task && typeof task === 'object' && Object.prototype.hasOwnProperty.call(task, 'task');
  const rawPayload = hasWrapper ? task.task : task;
  const { employeeId, ...payload } = rawPayload || {};
  payload.description = rawPayload?.description ?? null;
  // Same rule as saveTask: only post an assignee when the caller actually set
  // one, so forms that never touch assignment don't send an empty employeeId.
  if (rawPayload?.employeeId !== undefined) {
    payload.employeeId = rawPayload.employeeId;
  }
  const callback = hasWrapper && task.callback ? task.callback : undefined;
  const meta = hasWrapper && task.meta ? task.meta : undefined;
  return {
    type: API_REQUEST,
    callAPI: TaskAPI.postTask,
    data: payload,
    action: ADD_TASK,
    callback: callback || (() => fetchTasks(getLastTasksQuery())),
    errorCallback: hasWrapper ? task.errorCallback : undefined,
    closeModal: true,
    meta,
  };
};

export const addQuickTask = (task) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.postQuickTask,
  data: task,
  action: ADD_QUICK_TASK,
  callback: () => fetchQuickTasks(),
  closeModal: !(task?.addAnother === true),
});

export const getLastFourHoursTasks = () => ({
  type: API_REQUEST,
  callAPI: taskCompletionsAPI.getLastFourHoursTasks,
  action: GET_LAST_FOUR_HOURS_TASKS,
});

export const addTaskNote = (note) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.postTaskNote,
  data: note,
  action: ADD_TASK_NOTE,
  callback: () => getTask(note.id),
});

export const updateTaskNote = (payload) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.patchTaskNote,
  data: payload,
  action: UPDATE_TASK_NOTE,
  callback: () => getTask(payload.taskId),
});

export const saveTask = (data) => {
  const taskId = data?.task?.id;
  const callbackMeta = data?.callback;
  const isCallbackFunction = typeof callbackMeta === 'function' || Array.isArray(callbackMeta);
  const refreshCallback = () =>
    fetchTasks(isCallbackFunction ? getLastTasksQuery() : callbackMeta || getLastTasksQuery());
  const defaultCallback = taskId ? [refreshCallback, () => getTask(taskId)] : refreshCallback;
  const callback = isCallbackFunction ? callbackMeta : defaultCallback;
  const closeModal = data?.closeModal !== undefined ? data.closeModal : true;
  const { ...taskPayload } = data.task || {};
  taskPayload.description = data.task?.description ?? null;
  if (data.task?.employeeId !== undefined) {
    taskPayload.employeeId = data.task.employeeId;
  }
  if (data.task?.priority !== undefined) {
    taskPayload.priority = data.task.priority;
  }
  return {
    type: API_REQUEST,
    callAPI: TaskAPI.patchTask,
    data: taskPayload,
    action: SAVE_TASK,
    callback,
    errorCallback: data?.errorCallback,
    closeModal,
    meta: data && data.meta ? data.meta : undefined,
  };
};
export const deleteTask = (query) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.archiveTask,
  data: { id: query.id },
  action: DELETE_TASK,
  callback: query.callback,
  closeModal: true,
});
export const deleteQuickTask = (query) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.archiveQuickTask,
  data: { id: query.id },
  action: DELETE_QUICK_TASK,
  callback: query.callback,
  closeModal: true,
});

export const getTask = (id) => ({
  type: API_REQUEST,
  data: { id },
  callAPI: TaskAPI.getTask,
  action: GET_TASK,
});

export const getQuickTask = (id) => ({
  type: API_REQUEST,
  data: { id },
  callAPI: TaskAPI.getQuickTask,
  action: GET_QUICK_TASK,
});

export const getMaintenanceTask = (id) => ({
  type: API_REQUEST,
  data: { id },
  callAPI: TaskAPI.getTask,
  action: GET_MAINTENANCE_TASK,
});

export const deleteTaskInEdit = () => ({ type: DELETE_TASKINEDIT });

export const getTaskCompletions = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.getTaskCompletions,
    data: { query: query },
    action: GET_ALL_TASK_COMPLETIONS,
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
  };
};

export const getCompletedTaskCompletions = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.getTaskCompletions,
    data: { query: query },
    action: GET_COMPLETED_TASK_COMPLETIONS,
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
  };
};

export const getSnoozedTaskCompletions = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.getTaskCompletions,
    data: { query: query },
    action: GET_SNOOZED_TASK_COMPLETIONS,
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
  };
};

export const getTodaysTaskCompletions = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.getTaskCompletions,
    data: { query: { ...getTodaysTaskCompletionsDefaultQuery(), ...query } },
    action: GET_TODAYS_TASK_COMPLETIONS,
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
  };
};

export const fetchCompletionLogs = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.fetchCompletionLogs,
    data: { query },
    action: GET_COMPLETION_LOGS,
    meta: { permissionKey: viewPermissionRefs.task },
  };
};

export const addTaskFile = (data) => ({
  type: API_REQUEST,
  callAPI: FileApi.postTaskFile,
  data,
  action: ADD_TASK_FILE,
  closeModal: true,
  callback: () => getTask(data.taskId),
  errorCallback: () => hideDialog(),
});

export const deleteTaskFile = (data) => ({
  type: API_REQUEST,
  callAPI: FileApi.deleteTaskFile,
  data,
  action: DELETE_TASK_FILE,
  closeModal: true,
  callback: () => getTask(data.taskId),
});

export const unLinkTask = (task) => ({
  type: API_REQUEST,
  callAPI: TaskAPI.unLinkTask,
  data: task,
  action: UNLINK_TASK,
  callback: task.callback,
  closeModal: true,
});

export const getEssentialTasks = (query) => {
  return {
    type: API_REQUEST,
    callAPI: EssentialTaskAPI.getEssentialTasks,
    data: { query },
    action: GET_ESSENTIAL_TASKS,
  };
};

export const addEssentialTask = (task) => ({
  type: API_REQUEST,
  callAPI: EssentialTaskAPI.postEssentialTask,
  data: task,
  action: ADD_ESSENTIAL_TASK,
  callback: () => getEssentialTasks(),
  closeModal: true,
});

export const saveEssentialTask = (data) => ({
  type: API_REQUEST,
  callAPI: EssentialTaskAPI.patchEssentialTask,
  data: data.task,
  action: SAVE_ESSENTIAL_TASK,
  callback: data.callback,
  closeModal: true,
});

export const deleteEssentialTask = (query) => ({
  type: API_REQUEST,
  callAPI: EssentialTaskAPI.archiveEssentialTask,
  data: { id: query.id },
  action: DELETE_ESSENTIAL_TASK,
  callback: query.callback,
  closeModal: true,
});

export const setFromDate = (date) => ({ type: SET_TASK_FROM_DATE, date });
export const setUntilDate = (date) => ({ type: SET_TASK_UNTIL_DATE, date });

export const setTaskSelections = (rows) => ({
  type: SET_TASK_SELECTIONS,
  rows,
});
export const clearTaskSelections = () => ({ type: CLEAR_TASK_SELECTIONS });
export const clearMaintenanceTask = () => ({ type: CLEAR_MAINTENANCE_TASK });

export const getTaskPrefixes = () => ({
  type: API_REQUEST,
  callAPI: taskPrefixAPI.getTaskPrefixes,
  action: FETCH_TASK_PREFIXES,
});

export const getTaskLocations = () => ({
  type: API_REQUEST,
  callAPI: taskLocationAPI.getTaskLocations,
  action: FETCH_TASK_LOCATIONS,
});

export const setMaintenanceTask = (taskId) => ({
  type: GET_MAINTENANCE_TASK,
  taskId,
});

export const setTypeFilter = (value) => ({
  type: SET_TYPE_FILTER,
  value,
});

export const setIntervalFilter = (value) => ({
  type: SET_INTERVAL_FILTER,
  value,
});

export const setPrefixFilter = (value) => ({
  type: SET_PREFIX_FILTER,
  value,
});

export const setLocationFilter = (value) => ({
  type: SET_LOCATION_FILTER,
  value,
});

export const setEmployeeFilter = (value) => ({
  type: SET_EMPLOYEE_FILTER,
  value,
});

export const setStatusFilter = (value) => ({
  type: SET_STATUS_FILTER,
  value,
});

export const setCurrentEmployee = (value) => ({
  type: SET_CURRENT_EMPLOYEE,
  value,
});

export const clearNewTask = (value) => ({
  type: CLEAR_NEW_TASK,
  value,
});

export const getCalendarTaskCompletions = (query) => {
  return {
    type: API_REQUEST,
    callAPI: taskCompletionsAPI.getTaskCompletions,
    data: { query },
    action: GET_CALENDAR_TASK_COMPLETIONS,
    meta: { permissionKey: viewPermissionRefs.task, useManagerSiteId: true },
  };
};

export const fetchMaintenanceTaskCompletions = (query) => ({
  type: API_REQUEST,
  callAPI: taskCompletionsAPI.getTaskCompletions,
  data: {
    query: {
      pageSize: 5,
      type: 'Maintenance',
      date: moment().format('YYYY-MM-DD'),
      status: 'Pending',
      ...query,
    },
  },
  meta: { permissionKey: viewPermissionRefs.task },
  action: FETCH_MAINTENANCE_TASKS,
});
